export default {
    POS: 'POS',
    ONLINE: 'Online',
    OMNICHANNEL: 'Omnichannel',
    SLIDER: 'Slider',
    BARCODE: 'Barcode',
    MOBILE_DETAILS: 'Mobile_details',
    VORTEILSBON: 'Vorteilsbon'
}